module.exports = __webpack_public_path__ + "img/powered-by-august.b6d9e8df.svg";